module.exports = __webpack_public_path__ + "71fce7010594cb3ba37986b389b9ae4a.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-70.cur
// module id = 473
// module chunks = 0